export interface UnlockUser {
	guid: string;
	userGuid: string;
	firstName: string;
	lastName: string;
	emailAddress: string;
	organization: string;
	roleType: UserRoleType;
}

export type UserRoleType = keyof typeof UserRoleTypeMap;
export const UserRoleTypeMap = {
	CompanyUser: 'Company',
	BankUser: 'Bank',
	TeamMemberUser: 'Team Member',
	DealPartnerUser: 'Deal Partner',
	DataRoomUser: 'Data Room User',
};
